import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SvgSelector } from '../../../assets/icons/svg-selector';
import { ROUTES } from '../../../utils/router';
export const TasksHeader = () => {
    const { t } = useTranslation();
    return (_jsx("div", { className: "relative px-[20px]", children: _jsxs("div", { className: "flex items-center justify-between gap-[15px] py-[15px]", children: [_jsx(Link, { to: ROUTES.MENU, children: _jsx(SvgSelector, { id: "burger" }) }), _jsx("h3", { className: "text-sm leading-7 text-center", children: t('my-tasks-page.header-title') }), _jsx("div", {})] }) }));
};
